<template>
  <div id="login">
    <mt-header title class="dl_header_white">
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
      <router-link slot="right" to="/setlanguage">
        <svg
          t="1640658195311"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3507"
          width="20"
          height="20"
        >
          <path
            d="M848.804 805.57c70.999-81.259 109.778-184.212 109.778-293.14 0-119.204-46.418-231.275-130.714-315.566C744.873 113.869 634.936 67.62 517.786 66.217c-1.926-0.6-10.292-0.594-12.232 0.015-116.68 1.716-226.125 47.929-308.823 130.632-82.872 82.872-129.106 192.599-130.642 309.555-0.43 1.649-0.435 8.607-0.02 10.225 1.08 117.632 47.365 228.06 130.662 311.362 84.29 84.291 196.362 130.709 315.571 130.709 119.204 0 231.276-46.418 315.571-130.709a460.278 460.278 0 0 0 17.787-18.877 20.541 20.541 0 0 0 1.475-1.439 21.495 21.495 0 0 0 1.669-2.12zM107.448 532.046h187.505c1.32 65.674 9.252 127.263 22.507 182.108-61.69 16.691-100.817 38.374-121.077 51.907-52.07-64.728-84.706-145.705-88.935-234.015z m88.433-272.635c20.09 13.558 59.243 35.461 121.339 52.265-12.995 54.123-20.823 114.775-22.241 179.43H107.525c4.552-87.373 36.91-167.49 88.356-231.695zM917.079 491.1H729.631c-1.413-64.63-9.242-125.26-22.231-179.374 61.957-16.691 101.232-38.446 121.564-52.02 51.307 64.154 83.574 144.16 88.115 231.394z m-228.398 0H532.173V335.058c52.203-1.096 97.1-6.451 135.27-14.034 12.56 52.142 19.84 109.87 21.238 170.076zM532.168 294.113V109.921c36.838 10.399 72.78 49.203 100.925 110.014 8.812 19.036 16.645 39.639 23.465 61.522-35.026 6.768-76.298 11.607-124.39 12.656z m-40.945-183.838v183.802c-47.503-1.126-88.381-6-123.12-12.805 6.804-21.81 14.617-42.357 23.408-61.342 27.843-60.14 63.299-98.755 99.712-109.655z m0 224.768V491.1H335.928c1.388-60.216 8.679-117.954 21.243-170.102 37.837 7.537 82.314 12.887 134.052 14.045z m-155.33 197.002h155.33v158.663c-51.61 1.193-96.02 6.564-133.821 14.106-12.826-52.884-20.209-111.57-21.51-172.77z m155.33 199.623V914.58c-36.413-10.9-71.875-49.515-99.712-109.66-8.678-18.75-16.41-39.03-23.158-60.549 34.642-6.727 75.418-11.55 122.87-12.703z m40.945 183.27V731.608c47.897 1.024 89.098 5.862 124.114 12.657-6.754 21.555-14.495 41.876-23.189 60.656-28.145 60.81-64.082 99.62-100.925 110.019z m0-224.276V532.05h156.544c-1.3 61.097-8.658 119.685-21.443 172.498-38.113-7.532-82.949-12.836-135.101-13.886zM729.66 532.045h187.5c-4.219 88.135-36.73 168.975-88.622 233.636-20.47-13.67-59.633-35.303-121.303-51.871 13.204-54.758 21.104-116.224 22.425-181.765z m71.86-303.304c-18.33 11.571-52.311 29.358-104.858 43.495-19.297-63.053-46.11-115-78.06-150.974 70.395 19.149 133.233 56.837 182.918 107.48zM406.006 121.262c-31.903 35.922-58.69 87.772-77.978 150.702-52.403-14.244-86.37-32.102-104.581-43.586 49.628-50.463 112.333-88.013 182.559-107.116zM223.918 796.964c18.284-11.536 52.096-29.235 104.33-43.336 19.272 62.602 45.973 114.186 77.758 149.965-70.006-19.041-132.531-56.412-182.088-106.63z m394.68 106.629c31.8-35.804 58.517-87.424 77.789-150.083 51.983 14.024 85.975 31.632 104.535 43.203-49.593 50.345-112.2 87.808-182.324 106.88z"
            p-id="3508"
            fill="#1e86db"
          />
        </svg>
      </router-link>
    </mt-header>
    <div class="container" style="padding: 16px">
      <h3 class="dl_font1_color">
        <img :src="logo" class="login-logo" />
      </h3>
      <div
        :class="{
          'flex dl_font1_color dl_margin1_top': true,
          reverse: signType === 'email',
        }"
      >
        <div class="small" @click="changeSignType('phone')">
          {{ $t("手机登录") }}
        </div>
        <div class="small" @click="changeSignType('email')">
          {{ $t("邮箱登录") }}
        </div>
      </div>
      <div v-if="signType === 'phone'" class="area-wrap">
        <div class="area" @click="popupVisible = true">
          +{{ areacode }}
          <img src="../assets/img/login_ico_xia.png" alt />
        </div>
        <mt-field
          label
          :placeholder="$t('请填写手机号')"
          class="dl_margin4_top font-bold"
          v-model="mobileNum"
        ></mt-field>
      </div>
      <mt-field
        v-else
        label
        :placeholder="$t('请填写邮箱号')"
        class="dl_margin4_top font-bold"
        v-model="email"
      ></mt-field>
      <div class="dl_line"></div>
      <mt-field
        label
        :placeholder="$t('请填写密码')"
        class="dl_margin4_top"
        :type="ptype"
        v-model="password"
      >
        <img :src="eyesrc" height="18px" width="18px" @click="changeType()" />
      </mt-field>
      <div class="dl_line"></div>

      <div class="dl_main_color forget_pass">
        <router-link to="/forget" class="btn dl_font1_size">{{
          $t("忘记密码？")
        }}</router-link>
      </div>

      <mt-button
        type="primary"
        class="dl_margin4_top"
        size="large"
        @click="doLogin"
        >{{ $t("登录") }}</mt-button
      >
      <div
        class="dl_main_color dl_bottom"
        style="
          position: fixed;
          bottom: 20px;
          font-size: 15px;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
        "
      >
        <!-- <span class="huobi_login_color">{{
          $t("没有HMC Wallet Pro账号？")
        }}</span> -->
        <router-link to="/register" class="btn dl_font1_size">{{
          // $t("注册")
          $t("没有HMC Wallet Pro账号？ 注册")
        }}</router-link>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom">
      <!-- 号码区域选择组件 -->
      <select-area @onChange="onChangeArea" />
    </mt-popup>

    <two-check-dialog
      :temp-token="tempToken"
      :select_type="select_type"
      :showDialog="isShowDialog"
      @closeDialog="isShowDialog = false"
    ></two-check-dialog>
    <iframe
      class="hidden_iframe"
      src="https://www.metaearthex.com/wap/#/logout"
      frameborder="0"
    ></iframe>
    <iframe
      class="hidden_iframe"
      src="https://app2.alephrobot.com/app/#/logout"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import TwoCheckDialog from "../components/TwoCheckDialog";
import SelectArea from "@/components/SelectArea";
import { validateEmpty } from "@/utils/validate";
import { Toast } from "mint-ui";
import { httpDoLogin } from "@/api/login";
import { loginIn } from "@/utils/index";
import { validateEmail } from "../utils/validate";

export default {
  name: "Login",
  data() {
    return {
      ptype: "password",
      mobileNum: "",
      password: "",
      logo: require("../assets/img/login_logo.png"),
      eyesrc: require("../assets/img/login_ico_yanjing_bi.png"),
      res: {},
      picLyanzhengma: "",
      checkCode: "",
      code: "",
      popupVisible: false,
      areacode: "852",
      signType: "phone",
      email: "",
      isShowDialog: false,
      select_type: {
        google_authenticator: -1,
        mobile: "",
        email: "",
      },
      tempToken: "",
    };
  },
  methods: {
    changeType: function () {
      console.log(
        this.eyesrc == require("../assets/img/login_ico_yanjing_bi.png")
      );
      this.eyesrc =
        this.eyesrc == require("../assets/img/login_ico_yanjing_bi.png")
          ? require("../assets/img/ico_chakani_tanjkuang.png")
          : require("../assets/img/login_ico_yanjing_bi.png");
      this.ptype = this.ptype == "password" ? "text" : "password";
    },
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    // 图片验证码
    createCode() {
      this.code = "";
      var codeLength = 4; //验证码的长度
      var random = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ); //随机数
      for (var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
        this.code += random[index]; //根据索引取得随机数加到code上
      }
      this.checkCode = this.code; //把code值赋给验证码
      console.log(this.checkCode);
    },
    // 失焦验证图和密码
    checkLpicma() {
      this.picLyanzhengma.toUpperCase(); //取得输入的验证码并转化为大写
      if (this.picLyanzhengma == "") {
        Toast(this.$t("请输入验证码"));
        return false;
      } else if (this.picLyanzhengma.toUpperCase() != this.checkCode) {
        //若输入的验证码与产生的验证码不一致时
        Toast(this.$t("验证码不正确"));
        this.createCode(); //刷新验证码
        this.picLyanzhengma = "";
        return false;
      } else {
        //输入正确时
        return true;
      }
    },
    doLogin: function () {
      if (
        (validateEmpty(this.mobileNum) && validateEmpty(this.email)) ||
        validateEmpty(this.password)
      ) {
        Toast(this.$t("empty"));
        return;
      } else if (this.signType === "email" && !validateEmail(this.email)) {
        Toast(this.$t("邮箱地址不符合格式"));
        return;
      }

      var p = {
        username:
          this.signType === "phone"
            ? this.areacode + "-" + this.mobileNum
            : this.email,
        password: this.password,
        device_type: "web",
      };
      httpDoLogin(p)
        .then((res) => {
          //Toast(res.msg);
          if (res.code == 1) {
            //正常
            this.res = res;
            this.$store.dispatch("setToken", res.data.token);
            this.$store.dispatch("setUserInfo", res.data.user);
            this.$router.replace("/index/home");
            loginIn(res.data.token);
          } else if (res.code == 20001) {
            //二次验证，弹框
            this.tempToken = res.data.temp_token;
            this.select_type = res.data.method;
            this.isShowDialog = true;
          }

          // if (res.data.user.is_google_check == 1) {
          //   this.$router.push('/googleCheck?token=' + res.data.token)
          // } else {

          // }
        })
        .catch(() => {
          console.log("err");
        });
    },
    onChangeArea(value) {
      this.popupVisible = false;
      this.areacode = value;
    },
    changeSignType(type) {
      this.mobileNum = "";
      this.email = "";
      this.signType = type;
      this.password = "";
      this.areacode = 852;
    },
  },
  components: { Toast, SelectArea, TwoCheckDialog },
  activated: function () {
    this.createCode();
    this.mobileNum = "";
    this.password = "";
    this.select_type = {
      google_authenticator: -1,
      mobile: "",
      email: "",
    };
    if (this.$route.query.result && this.res.data) {
      this.$store.dispatch("setToken", this.res.data.token);
      this.$store.dispatch("setUserInfo", this.res.data.user);
      this.$router.replace("/index/home");
    }
  },
  watch: {
    popupVisible: function (val) {
      console.log(val);
      this.popupVisible = val;
    },
  },
};
</script>

<style scoped>
#login {
  height: 100%;
}

#code {
  width: 80px;
  height: 30px;
  -webkit-appearance: button;
  color: #1b85d7;
}

.container {
  padding: 10px;
}

.forget_pass {
  font-size: 14px;
  margin: 10px 0 50px;
  float: right;
}

a {
  color: #879baa;
  font-weight: 500;
}

.btn {
  color: #1e86db;
}

.mint-button--primary {
  background-color: #1e87d9;
}

.dl_bottom {
  position: fixed;
  bottom: 20px;
}

.font_bold {
  font-weight: 500;
}

.dl_margin_left {
  margin-left: 10px;
}

.mint-cell {
  min-height: 40px;
}

.huobi_color {
  color: #c6cacd;
}

.huobi_login_color {
  color: #c9ced2;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  line-height: 1;
  font-size: 14px;
  color: #1e87d9;
}

.flex.reverse {
  flex-direction: row-reverse;
}

.flex .small {
  cursor: pointer;
}

.flex .small:first-child,
.flex.reverse .small:last-child {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
}

.flex.reverse .small:first-child {
  font-size: 1em;
  font-weight: normal;
  color: #1e87d9;
}

.hidden_iframe {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
</style>
